export { default as LikeIcon } from './LikeIcon';
